import { render, staticRenderFns } from "./AddBalance.vue?vue&type=template&id=48d69635&scoped=true&"
import script from "./AddBalance.vue?vue&type=script&lang=js&"
export * from "./AddBalance.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=48d69635&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d69635",
  null
  
)

export default component.exports